import { endOfDay, parse, startOfDay, subDays } from "date-fns";

import { HistoryPageQueryParams, Range } from "@zapier/reporting/src/types";

export function getDateRangeFromQuery(
  query: Partial<HistoryPageQueryParams>,
  billingPeriod?: Partial<Range<string>>
) {
  return {
    from: getDateWithTime(query.start_datetime, false, billingPeriod?.from),
    hasChange: false,
    to: getDateWithTime(query.end_datetime, true, billingPeriod?.to),
  };
}

function getDateWithTime(
  rawDateString: string | undefined,
  isEnd: boolean,
  billingPeriodDate?: string
) {
  const today = new Date();
  const end = endOfDay(today).toISOString();
  const start = startOfDay(subDays(today, 29)).toISOString();

  // If billing period is provided and no query param, use billing period as default
  const defaultDate = billingPeriodDate || (isEnd ? end : start);

  if (rawDateString === undefined) {
    return defaultDate;
  }

  // Sometimes we get the encoded string for the date which
  // would normally cause this to crash so decode it if there is
  // encoding included
  const dateString = rawDateString.includes("%")
    ? decodeURIComponent(rawDateString)
    : rawDateString;

  // if the date is already in timestamp format ("2021-03-10T23:59:59.999Z") then
  // just return it to be passed to the backend
  if (dateString.includes("T")) {
    return dateString;
  }

  // If dateString is not a date, then return undefined to not filter by it
  const date = parse(dateString, "yyyy-MM-dd", today);
  if (
    dateString === undefined ||
    !(date instanceof Date) ||
    isNaN(date.valueOf())
  ) {
    return defaultDate;
  }

  let ret;
  if (isEnd) {
    ret = endOfDay(date).toISOString();
  } else {
    ret = startOfDay(date).toISOString();
  }

  return ret;
}
